import helpers from "../utils/helpers"
export const FormMixin = {
    methods: {
        validarFormulario: function (prefix = "", validacaoEscondida = false) {
            let arValidation = [];

            for (let ref in this.$refs) {
                if (!ref.includes(prefix)) continue;

                if (this.$refs[ref] == undefined) continue;

                //console.log(ref, this.$refs[ref], typeof this.$refs[ref], this.$refs[ref].length);
                if (this.$refs[ref].length == 0 || this.$refs[ref].length == undefined) {
                    // Componentes sem o contrato de validação (ex.: InputCheckbox) são ignorados.
                    if (typeof this.$refs[ref].valid !== 'function') continue;

                    try {
                        arValidation.push(this.$refs[ref].valid(validacaoEscondida));
                    } catch (e) {
                        console.error('Erro ao validar o campo: ', ref, e);
                    }
                } else {
                    for (let i = 0; i < this.$refs[ref].length; i++) {
                        if (typeof this.$refs[ref][i].valid !== 'function') continue;

                        arValidation.push(this.$refs[ref][i].valid(validacaoEscondida));
                    }
                }
            }

            return arValidation.filter((elem) => elem == false).length == 0;
        },
        limparFormulario: function (prefix = "") {

            for (let ref in this.$refs) {
                if (!ref.includes(prefix)) continue;

                if (this.$refs[ref] == undefined) continue;

                //console.log(ref, this.$refs[ref], typeof this.$refs[ref], this.$refs[ref].length);
                if (this.$refs[ref].length == 0 || this.$refs[ref].length == undefined) {
                    // Componentes sem o contrato de limpeza (ex.: InputCheckbox) são ignorados.
                    if (typeof this.$refs[ref].clear !== 'function') continue;

                    try {
                        this.$refs[ref].clear();
                    } catch (e) {
                        console.error('Erro ao limpar o campo: ', ref, e);
                    }
                } else {
                    for (let i = 0; i < this.$refs[ref].length; i++) {
                        if (typeof this.$refs[ref][i].clear !== 'function') continue;

                        this.$refs[ref][i].clear();
                    }
                }
            }

        },
        retornarVariante: function (situacao) {
            return helpers.Situacao.find(el => el.value == situacao);
        },
        retornarVarianteLigado: function (ligado) {
            return helpers.Ligado.find((el) => el.value == ligado);
        },
        retornarSimNao: function (valor) {
            return helpers.SimNao.find(el => el.value == valor);
        },
    },
}